import { addDoc, collection } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./request-rent-slice";

export const addRequestToRentService = async (dispatch, db, coll, formData) => {
    dispatch(showLoading());
    try {
        await addDoc(collection(db, coll), formData);
        // dispatch(addCategories({
        //     id: docRef.id,
        //     ...formData
        // }));
        dispatch(showSuccessSnackbar('Request to rent submitted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'))
        console.error("ItemCategoriesAdd addItemCategoriesService error: ", e);
    }
    dispatch(hideLoading());
};